import { devices } from "../_helpers/constants";

export const setDevice = () => {
  const width = window.innerWidth;

  if (width < devices.xsmall.size) {
    window.device = devices.xsmall.name;
  } else if (width >= devices.xsmall.size && width < devices.small.size) {
    window.device = devices.small.name;
  } else if (width >= devices.small.size && width < devices.medium.size) {
    window.device = devices.medium.name;
  } else if (width >= devices.medium.size && width < devices.large.size) {
    window.device = devices.large.name;
  } else {
    window.device = devices.xlarge.name;
  }
};

export const isMobileDevice = () => {
  return (
    window.device === devices.xsmall.name ||
    window.device === devices.small.name
  );
};

export const isTabletDevice = () => {
  return window.device === devices.medium.name;
};

export const isDesktopDevice = () => {
  return window.device === devices.large.name;
};

export const isLargeDesktopDevice = () => {
  return window.device === devices.xlarge.name;
};
